class CountdownTimer extends HTMLElement {
  connectedCallback() {
    const durationMinutes = parseInt(this.dataset.durationMinutes, 10) || 180;
    const durationMs = durationMinutes * 60 * 1000;
    const storageKey = this.dataset.storageKey || 'countdown-timer';

    let deadline = parseInt(window.localStorage.getItem(storageKey), 10);
    if (!deadline || deadline < Date.now()) {
      deadline = Date.now() + durationMs;
      window.localStorage.setItem(storageKey, deadline);
    }
    this.deadline = deadline;
    this.storageKey = storageKey;

    this.hoursEl = this.querySelector('[data-unit="hours"]');
    this.minutesEl = this.querySelector('[data-unit="minutes"]');
    this.secondsEl = this.querySelector('[data-unit="seconds"]');

    this.tick = this.tick.bind(this);
    this.tick();
    this.interval = setInterval(this.tick, 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const remaining = Math.max(0, this.deadline - Date.now());
    const totalSeconds = Math.floor(remaining / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.hoursEl.textContent = String(hours).padStart(2, '0');
    this.minutesEl.textContent = String(minutes).padStart(2, '0');
    this.secondsEl.textContent = String(seconds).padStart(2, '0');

    if (remaining <= 0) {
      clearInterval(this.interval);
      window.localStorage.removeItem(this.storageKey);
    }
  }
}

customElements.define('countdown-timer', CountdownTimer);
